import {
    PURCHASE_ORDER_BALANCE_STOCK_REPORT_REQUEST,
    PURCHASE_ORDER_BALANCE_STOCK_REPORT_SUCCESS,
    PURCHASE_ORDER_BALANCE_STOCK_REPORT_FAILURE,
    PURCHASE_ORDER_BALANCE_STOCK_FILTER_REPORT_REQUEST,
    PURCHASE_ORDER_BALANCE_STOCK_FILTER_REPORT_SUCCESS,
    PURCHASE_ORDER_BALANCE_STOCK_FILTER_REPORT_FAILURE,
    PURCHASE_ORDER_BALANCE_CHALLAN_BASE_STOCK_REPORT_SUCCESS,
    SET_PURCHASE_OUTSTANDING_BY_ACCOUNTS
  } from "../types/purchase-order-balance-stock-report-types";
  
  const initialState = {
    purOrderBalanceBillBaseStockReport: {},
    purOrderBalanceBillBaseStockFilterOptions: {},
    purOrderBalanceChallanBaseStockReport: {},
    outstandingByAccounts: {},
    loading: false,
    error: null,
  };
  
  const purchaseOrderBalanceStockReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case PURCHASE_ORDER_BALANCE_STOCK_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null,
          purOrderBalanceBillBaseStockReport: {}
        };
      }
      case PURCHASE_ORDER_BALANCE_STOCK_FILTER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case PURCHASE_ORDER_BALANCE_STOCK_REPORT_SUCCESS: {
        return {
          ...state,
          purOrderBalanceBillBaseStockReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case PURCHASE_ORDER_BALANCE_STOCK_FILTER_REPORT_SUCCESS: {
        return {
          ...state,
          purOrderBalanceBillBaseStockFilterOptions: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case PURCHASE_ORDER_BALANCE_CHALLAN_BASE_STOCK_REPORT_SUCCESS: {
        return {
          ...state,
          purOrderBalanceChallanBaseStockReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case SET_PURCHASE_OUTSTANDING_BY_ACCOUNTS: {
        return {
          ...state,
          outstandingByAccounts: {...(action.payload || {})},
          loading: false,
          error: null
        }
      }
      case PURCHASE_ORDER_BALANCE_STOCK_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      case PURCHASE_ORDER_BALANCE_STOCK_FILTER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default purchaseOrderBalanceStockReportReducer;
  